// extracted by mini-css-extract-plugin
export default {"paymentSection":"g8-z"};